var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-item"},[_c('SimpleBullet',{attrs:{"width":375,"height":12,"percent":_vm.percent * 100.0}}),_c('div',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }